<div class="my-ranking-card">
    <div class="my-ranking-card__header">
        <p #metricNameElement class="my-ranking-card__metric ellipsis" [tooltip]="isTextTruncated() ? metricNameTooltip : ''" containerClass="cxone-tooltip-my-rank" container="body" placement="bottom">
            {{myRank.metricName}}
        </p>
        <ng-template #metricNameTooltip>
            <p class="my-ranking-card__tooltip mb-0">
                {{myRank.metricName}}
            </p>
        </ng-template>
        <p [ngClass]="{'my-ranking-card__no-rank': myRank.ranking === 3}" class="my-ranking-card__value">
            {{getInfo('value')}}
        </p>
    </div>
    <div class="my-ranking-card__body">
        <div class="my-ranking-card__position">
            <div class="my-ranking-card__position-text">
                <p cvLocalizedText [langSection]="'My_Ranking'"
                [langKey]="'Current_Position'" class="my-ranking-card__position-label">
                    Current Position:
                </p>
                <p [ngClass]="{'my-ranking-card__no-rank': myRank.ranking === 3}" class="my-ranking-card__position-value">
                    {{getInfo('position')}}
                </p>
            </div>
            <div class="my-ranking-card__position-text">
                <p cvLocalizedText [langSection]="'My_Ranking'"
                [langKey]="'Percentile'" class="my-ranking-card__position-label">
                    Percentile:
                </p>
                <p [ngClass]="{'my-ranking-card__no-rank': myRank.ranking === 3}" class="my-ranking-card__position-value">
                    {{getInfo('percentile')}}
                </p>
            </div>
        </div>
        <div class="my-ranking-card__position">
            <p cvLocalizedText [langSection]="'My_Ranking'"
            [langKey]="'My_Rank'" class="my-ranking-card__position-label">
                My Rank
            </p>
            <div class="my-ranking-card__position-icon" [ngClass]="{'align-self-center': myRank.ranking === 3}">
                <svg class="my-ranking-card__position-icon-svg" [ngClass]="{'d-none': myRank.ranking === 3}">
                    <use [attr.href]="getSourceIcon(myRank.ranking)"></use>
                </svg>
                <p [ngClass]="getClass(myRank.ranking)">{{getInfo('icon')}}</p>
            </div>
        </div>
    </div>
</div>